import { useQuery } from "@tanstack/react-query";
import { ListChecks } from "lucide-react";
import { JobsTable } from "@/components/jobs/JobsTable";
import { DraftBanner } from "@/components/shared/draft-banner";
import { EmptyState } from "@/components/shared/empty-state";
import { ErrorState } from "@/components/shared/error-state";
import { PageHeader } from "@/components/shared/page-header";
import { Skeleton } from "@/components/ui/skeleton";
import {
  fetchMassUpdateJobs,
  hasActiveMassUpdateJob,
  massUpdateJobsKeys,
} from "@/mocks/mass-update-jobs";

export function JobsPage() {
  const {
    data: jobs,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: massUpdateJobsKeys.all,
    queryFn: fetchMassUpdateJobs,
    refetchInterval: (query) => (hasActiveMassUpdateJob(query.state.data) ? 2000 : false),
  });

  return (
    <div className="space-y-6">
      <DraftBanner
        epic="EPIC-010"
        run="HR-001"
        subtitle="Jobs — queued, in progress, complete, or failed. Draft only; jobs live in this browser tab."
      />
      <PageHeader
        title="Jobs"
        description="Every batch of changes shows up here, with the reason if something didn't go through."
      />
      {isError ? (
        <ErrorState message="Couldn't load jobs." onRetry={() => refetch()} />
      ) : isLoading || !jobs ? (
        <Skeleton className="h-64 w-full rounded-xl" />
      ) : jobs.length === 0 ? (
        <EmptyState
          icon={ListChecks}
          title="No jobs yet"
          description="Apply a change on Sales Orders or Work Orders, or run an import, and it'll show up here."
        />
      ) : (
        <JobsTable jobs={jobs} />
      )}
    </div>
  );
}
